import Phaser from "phaser";
import { REFERENCE_HEIGHT, REFERENCE_WIDTH } from "../game/constants";
import { ProgressionService } from "../systems/ProgressionService";
import { LeaderboardService } from "../systems/LeaderboardService";
import { LeaderboardPanel } from "../ui/LeaderboardPanel";

export class MainMenuScene extends Phaser.Scene {
    private leaderboardPanel?: LeaderboardPanel;
    private leaderboardVisible = false;

    constructor() {
        super("MainMenuScene");
    }

    create(): void {
        this.add.rectangle(REFERENCE_WIDTH / 2, REFERENCE_HEIGHT / 2, REFERENCE_WIDTH, REFERENCE_HEIGHT, 0x0f3b58);

        this.add
            .text(REFERENCE_WIDTH / 2, 240, "SPEAR FEST", {
                fontSize: "96px",
                fontStyle: "bold",
                color: "#f5f8ff",
            })
            .setOrigin(0.5);

        const startButton = this.add
            .text(REFERENCE_WIDTH / 2, 420, "Press Enter or Click to Start", {
                fontSize: "42px",
                color: "#d6ecff",
            })
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true });

        this.add
            .text(REFERENCE_WIDTH / 2, 500, `Lifetime Score: ${ProgressionService.getLifetimeScore()}`, {
                fontSize: "34px",
                color: "#b9e6ff",
            })
            .setOrigin(0.5);

        const leaderboardButton = this.add
            .text(REFERENCE_WIDTH / 2, 565, "View Leaderboard", {
                fontSize: "32px",
                color: "#9ce6ff",
                backgroundColor: "#21455f",
                padding: { left: 18, right: 18, top: 10, bottom: 10 },
            })
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true });

        this.leaderboardPanel = new LeaderboardPanel(this, REFERENCE_WIDTH / 2, REFERENCE_HEIGHT / 2 + 190, 640, 520);
        this.leaderboardPanel.render(LeaderboardService.getTopScores());
        this.leaderboardPanel.setVisible(false);

        leaderboardButton.on("pointerdown", () => {
            this.leaderboardVisible = !this.leaderboardVisible;
            this.leaderboardPanel?.setVisible(this.leaderboardVisible);
        });

        startButton.on("pointerdown", () => this.scene.start("LakeSelectScene"));
        this.input.keyboard?.once("keydown-ENTER", () => this.scene.start("LakeSelectScene"));
    }
}
